import dl from '@/assets/images/homeImages/dl.png'
import tbr from '@/assets/images/homeImages/tbr.png'
import jd from '@/assets/images/homeImages/jd.png'
import zj from '@/assets/images/homeImages/zj.png'
import yz from '@/assets/images/homeImages/yz.png'
import cgzq from '@/assets/images/homeImages/cgzq.png'
import qyhzs from '@/assets/images/homeImages/qyhzs.png'
import kpbs from '@/assets/images/homeImages/kpbs.png'
import pbzj from '@/assets/images/homeImages/pbzj.png'
import gzzc from '@/assets/images/homeImages/gzzc.png'
import xz from '@/assets/images/homeImages/xz.png'
import lunbo from '@/assets/images/homeImages/lunbo.png'
import pb from  '@/assets/images/homeImages/pb.png'
import jdZs from  '@/assets/images/homeImages/jdZs.png'
export const home = {
    dl, tbr, jd, zj,yz,cgzq,qyhzs,
  kpbs, pbzj, lunbo, gzzc, xz,
    pb,jdZs
}
import kf from '@/assets/images/rightMenuImages/kf.png'
import ewm from '@/assets/images/rightMenuImages/ewm.png'
import fhdb from '@/assets/images/rightMenuImages/fhdb.png'
import apkCode from '@/assets/images/rightMenuImages/apkCode.png'
import yj from '@/assets/images/rightMenuImages/yj.png'
import kf1 from '@/assets/images/rightMenuImages/kf1.png'
import ewm1 from '@/assets/images/rightMenuImages/ewm1.png'
import fhdb1 from '@/assets/images/rightMenuImages/fhdb1.png'
import yj1 from '@/assets/images/rightMenuImages/yj1.png'
import apkCode1 from '@/assets/images/rightMenuImages/apkCode1.png'
import bj from '@/assets/images/rightMenuImages/bj.png'
export const rightMenu = {
    kf,ewm,fhdb,apkCode,yj,kf1,ewm1,fhdb1,yj1,apkCode1,bj
}
import Group from '@/assets/images/bottomText/Group.png'
import dh from '@/assets/images/bottomText/dh.png'
import yx from '@/assets/images/bottomText/yx.png'
export const bottomText = {
    Group,dh,yx
}